import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-composiciones-cantadas-himnos',
  templateUrl: './composiciones-cantadas-himnos.component.html',
  styleUrls: ['./composiciones-cantadas-himnos.component.scss']
})
export class ComposicionesCantadasHimnosComponent implements OnInit {

  slides = [
    { id: "https://hdl.handle.net/20.500.14428/65631", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img002.jpg", autor: "Himno Nacional del Perú para piano", titulo: "Música de don Bernardo Alsedo arreglada por Carlos Eklund,", ano: "1863" },
    { id: "https://hdl.handle.net/20.500.14428/65623", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img003.jpg", autor: "Himno Nacional del Perú", titulo: "José Bernardo Alcedo, ", ano: " Ca. 1900" },
    { id: "https://hdl.handle.net/20.500.14428/65622", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img004.jpg", autor: "Himno Nacional del Perú. Reducción para canto y piano", titulo: "Música del maestro José Bernardo Alcedo,", ano: " Ca. 1890 " },
    {
      id: "https://hdl.handle.net/20.500.14428/65626", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img005.jpg", autor: "Himno Nacional del Perú. Arreglo para canto y piano", titulo: "Música de Bernardo de Alcedo,", ano: " Ca. 1900"
    },
    {
      id: "https://hdl.handle.net/20.500.14428/65625", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img006.jpg", autor: "Himno Nacional del Perú reducción para piano", titulo: "Música del maestro José Bernardo Alzedo,", ano: "1901"
    },
    { id: "https://hdl.handle.net/20.500.14428/65624", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img007.jpg", autor: "Himno Nacional del Perú para canto y piano", titulo: "Música de D. Bernardo Alzedo,", ano: " Ca. 1900" },
    {
      id: "https://hdl.handle.net/20.500.14428/65629", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img008.jpg", autor: "Himno Nacional del Perú", titulo: "Música de José Bernardo Alzedo,", ano: "Ca. 1942 "
    },
    {
      id: "https://hdl.handle.net/20.500.14428/65630", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img009.jpg", autor: "Himno Nacional Peruano ", titulo: "Edición para piano,", ano: "  Ca. 1942 "
    },
    {
      id: "https://hdl.handle.net/20.500.14428/65631", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img010.jpg", autor: "Himno Nacional del Perú", titulo: "Música del maestro José Bernardo Alzedo, restaurado, armonizado e instrumentado con plena aprobación del autor por Claudio Rebagliati,", ano: " Ca. 1946"
    },
    {
      id: "https://hdl.handle.net/20.500.14428/65632", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img011.jpg", autor: "Himno Nacional del Perú, canto y piano", titulo: "Letra de José de la Torre Ugarte, música de José Bernardo Alcedo, restauración y armonización de Claudio Rebagliati,", ano: " Ca. 1951 "
    },
    {
      id: "http://hdl.handle.net/20.500.14428/79603", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img012.jpg", autor: "Himno Nacional del Perú en quechua", titulo: "Traducido por Eustaquio Rodríguez Aweranka,  ", ano: "Ca. 1950"
    },
    {
      id: "http://hdl.handle.net/20.500.14428/79604", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img013.jpg", autor: "Himno Nacional en Aymara", titulo: "Traducido por Eustaquio Rodríguez Aweranka, ", ano: "Ca. 1950"
    },
  ];

  slides2 = [
    { id: "https://hdl.handle.net/20.500.14428/65695", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img023.jpg", descripcion: "Himno al maestro peruano", subtexto: "Letra de Arturo Montoya, música de Carlos Rodríguez Pastor,", ano: " Ca. 1900 " },
    { id: "https://hdl.handle.net/20.500.14428/65656", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img024.jpg", descripcion: "Himno del Colegio Militar Leoncio Prado", subtexto: "Letra de Anaximandro Vega, música de Monseñor Pablo Chávez Aguilar,", ano: "1946" },
    { id: "http://hdl.handle.net/20.500.14428/79095", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img025.jpg", descripcion: "Himno del Externado de Santo Toribio ", subtexto: "Música de Pablo Chávez Aguilar, letra del Ángel Ruiz Fernández,  ", ano: "Ca. 1940" },
    { id: "http://hdl.handle.net/20.500.14428/79097 ", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img027a.jpg", descripcion: "Himno de la Escuela Normal Urbana de Huancayo ", subtexto: "Música de Carmen Cáceres de Pastor y letra de Sara Fernández de Córdova de Hurtado, ", ano: "Ca. 1950" },
    { id: "https://hdl.handle.net/20.500.14428/65611", img: "/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img026.jpg", descripcion: "Defendamos la bandera. Himno escolar patriótico ", subtexto: "Letra de Teobaldo Elías Corpancho, música de Romualdo E. Alva,", ano: " Ca. 1935" },
  ];

  slideConfig = {
    "slidesToShow": 5, "slidesToScroll": 1, "responsive": [
      {
        'breakpoint': 800,
        'settings': {
          'slidesToShow': 1
        }
      },

    ]
  };

  constructor(private titleService: Title) {
    this.titleService.setTitle("COMUNIDADES CANTADAS LAS COMPOSICIONES DE HIMNOS");
  }

  ngOnInit(): void {
  }



}
